import { Box, styled } from '@mui/material';

export const StyledContainer = styled(Box)`
    padding: 20px;
    min-width: 600px;
    display: flex;
    flex-direction: column;
`;
export const StyledButtonContainer = styled(Box)`
    margin-top: 30px;
    display: flex;
    justify-content: space-around;
`;
